'use client';

import { useParams } from 'next/navigation';

import { COMMON_I18N } from '@/lib/i18n/commonI18n';
import { resolveAppLocale } from '@/lib/i18n/routing';

const SkipToContent = () => {
  const params = useParams();
  const locale = resolveAppLocale(params.locale as string);

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-xs focus:text-sm focus:font-semibold"
    >
      {COMMON_I18N[locale].skipToContent}
    </a>
  );
};

export default SkipToContent;
